var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 43,
    viewBox: "0 0 43 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 21.5,
    cy: 21.5,
    r: 21.5,
    fill: "#E6E6E6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.5729 12C24.4778 12 26.8557 14.3779 26.8557 17.2829C26.8557 19.0592 25.9631 20.6321 24.6083 21.589C27.7619 22.8531 30 25.9372 30 29.5351C29.9952 29.7526 29.9054 29.9595 29.7499 30.1115C29.5944 30.2636 29.3855 30.3489 29.168 30.3489C28.9505 30.3489 28.7416 30.2636 28.5861 30.1115C28.4306 29.9595 28.3409 29.7526 28.336 29.5351C28.336 25.7162 25.2569 22.6387 21.438 22.6387C17.6192 22.6387 14.5417 25.7162 14.5417 29.5351C14.5417 29.756 14.4539 29.9677 14.2977 30.1239C14.1416 30.2801 13.9297 30.3679 13.7089 30.3679C13.488 30.3679 13.2762 30.2801 13.12 30.1239C12.9638 29.9677 12.8761 29.756 12.8761 29.5351C12.8761 25.869 15.2015 22.7395 18.4497 21.5224C17.1478 20.56 16.2982 19.0192 16.2982 17.2829C16.2982 14.3779 18.668 12 21.5729 12ZM21.5729 13.6656C19.5672 13.6656 17.9622 15.2772 17.9622 17.2829C17.9622 19.2885 19.5672 20.8935 21.5729 20.8935C23.5786 20.8935 25.1901 19.2885 25.1901 17.2829C25.1901 15.2772 23.5786 13.6656 21.5729 13.6656Z",
    fill: "#033476"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon4);
export default __webpack_public_path__ + "static/media/icon4.a0b10282027d80efc1142dfc1ebf46e8.svg";
export { ForwardRef as ReactComponent };